import { CHANGE_EVENT_PREFERENCES } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { FullUserBoundary } from '@ui/general';
import { SalesforceButton } from './SalesforceButton';
import { SyncOutlined } from '@ant-design/icons';
import { useAction } from '@hooks';

import { Button, Space } from 'antd';
import React, { useCallback } from 'react';

export interface MonitoredObjectsButtonsProps {
    refreshing: boolean;
    salesforceUrl?: string;
    onRefresh: () => void;
}

export const MonitoredObjectsButtons : React.FC<MonitoredObjectsButtonsProps> = ({
	refreshing,
	salesforceUrl,
	onRefresh
}) => {
	const postDataSecurityStatus = useAction(coreActions.requestPostCoreDataSecurityStatus);

	const handleRefreshClick = useCallback(() => {
		postDataSecurityStatus({
			enable: true
		});
		onRefresh();
	}, [ postDataSecurityStatus, onRefresh ]);

	const handleManageClick = useCallback(() => {
		postDataSecurityStatus({
			enable: false
		});
	}, [ postDataSecurityStatus ]);

	return	(
		<FullUserBoundary>
			<Space
				align='center'
				className='edit-buttons'>
				<Button
					disabled={ refreshing }
					icon={ <SyncOutlined /> }
					onClick={ handleRefreshClick }>
					{ CHANGE_EVENT_PREFERENCES.REFRESH_OBJECTS }
				</Button>
				<SalesforceButton
					href={ salesforceUrl }
					name={ CHANGE_EVENT_PREFERENCES.MANAGE_OBJECTS }
					onClick={ handleManageClick } />
			</Space>
		</FullUserBoundary>
	);
};
